<template>
  <div id="bscdown2">
    <div class="box">
      <div id="bscdown2div" style="height:96%;width:96%;margin-top:10px"></div>
    </div>
  </div>
</template>

<script>
// 2：导入echarts
import echarts from 'echarts';
import { AREA_LIST, BU_LIST, MONTH_NAME } from '../mainPage/area_bu'

export default {
  name: 'bscdown2',
  data() {
    return {
      // 需要合并对象，样式
      dataset: []
    };
  },
  created() {},
  mounted() {
    //   mounted 函数表示已经DOM渲染完成
  },
  methods: {
    goto() {
      this.$router.push('/bscpage2');
    },
    getMinValue(arr) {
      let minValue = 999999
      for (let n = 0; n < arr.length; n++) {
        for (let i = 0; i < arr[n].length; i++) {
          if (arr[n][i] < minValue)
            minValue = arr[n][i]
        }
      }
      return minValue
    },
    getMaxValue(arr) {
      let maxValue = -999999
      for (let n = 0; n < arr.length; n++) {
        for (let i = 0; i < arr[n].length; i++) {
          if (arr[n][i] > maxValue)
            maxValue = arr[n][i]
        }
      }
      return maxValue
    },
    refreshChart(chartData) {
      const { getMinValue, getMaxValue } = this
      var that = this

      // 生成数据
      //const serColors = ['#4472C4', '#ED7D31', '#A4A4A4', '#FFC000', '#00B050']
      const serColors = ['#ED7D31', '#1E90FF', '#70DF00', '#FFC000', '#00B050']
      const serTitle = []
      const markLineOptList = []
      this.dataset = []
      const data1 = []
      const data2 = []
      const data3 = []
      const data4 = []
      const data5 = []
      for (let i = 1; i <= 13; i++) {
        var itemData = chartData['' + i]
        if (itemData == undefined) {
          continue
        }
        //serTitle.push(itemData.Month + '月')
        if (i <= 12) {
          MONTH_NAME.forEach(x => {
            if (x.value == itemData.Month) {
              serTitle.push(x.label)
            }
          })
        } else {
          serTitle.push('Year')
        }
        data1.push(itemData.BaseEnByOutValue)
        data2.push(itemData.EnByOutPlanValue)
        if (itemData.EnByOutPracticalValue > 0)
          data3.push(itemData.EnByOutPracticalValue)
        else
          data3.push(undefined)
        if (itemData.HealthRate != 0)
          data4.push(itemData.HealthRate)
        else
          data4.push(undefined)
        data5.push(itemData.IsPredict)
      }
      this.dataset = [data1, data2, data3, data4, data5]
      let minValue = getMinValue([data1, data2, data3])
      let maxValue = getMaxValue([data1, data2, data3])
      let minHealth = getMinValue([data4])
      let maxHealth = getMaxValue([data4])
      let maxHealthY = Math.ceil((maxHealth + Math.abs(minHealth)) / (minValue / maxValue) * 1)
      let minHealthY = Math.floor(minHealth)
      if (minHealthY > 0) {
        minHealthY = 0
      }
      let minYValue = -1 * maxValue

      var myChart = echarts.init(document.getElementById('bscdown2div'));
      myChart.clear()
      var option = {
        title: {
          text: this.locale('Health','健康度'),
          textStyle: {
            color: '#fff',
            fontSize: 24
          },
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: function(params) {
            var str = '';
            str += params[0].name;
            var now = new Date();
            for (var i = 0; i < params.length; i++) {
              if (params[i].value != undefined)
                str += '<br/>' + params[i].seriesName + ':' + params[i].value;
            }
            return str;
          }
        },
        color: serColors,
        legend: {
          x: 'right',
          y: -4,
          textStyle: {
            color: '#ffffff',
            fontSize: 16
          },
          data: [
            {name: this.locale('Base','基准')},
            {name: this.locale('Target','目标')},
            {name: this.locale('Actual','实际')},
            {
              name: this.locale('Health','健康度'),
              icon: 'image://' + require('./img/Health.png')
            }
          ]
        },
        xAxis: {
          data: serTitle,
          axisLabel: {
            interval: 0,
            color: '#ffffff',
            fontSize: 16
          },
          name: '',
          nameTextStyle: {
            color: '#ffffff',
            fontSize: 16
          },
          splitLine: {
            show: false
          },
          axisLine: {
            // 轴线
            lineStyle: {
              color: '#7f8fa4'
            }
          }
        },
        yAxis: [{
          scale: true,
          name: this.locale('Health','健康度'),
          nameTextStyle: {
            color: '#ffffff',
            fontSize: 16
          },
          axisLabel: {
            color: '#ffffff',
            interval: 'auto',
            formatter: '{value} %',
            fontSize: 16
          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#7f8fa4'
            }
          },
          max: maxHealthY,
          min: minHealthY
        }, {
          scale: true,
          name: this.locale('tce/¥10K','万元产值能耗'),
          nameTextStyle: {
            color: '#ffffff',
            fontSize: 16
          },
          min: minYValue,
          axisLabel: {
            color: function(value) {
               if (value <= 0) {
                 return 'transparent'
               }
               return '#fff'
             },
            fontSize: 16
          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#7f8fa4'
            }
          }
        }],
        series: [
          {
            name: this.locale('Base','基准'),
            type: 'line',
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: serColors[0],
                fontSize: 16,
                lineStyle: {
                  width: 3
                }
              }
            },
            symbol: 'diamond',
            data: this.dataset[0]
          },
          {
            name: this.locale('Target','目标'),
            type: 'line',
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: serColors[1],
                fontSize: 16,
                lineStyle: {
                  width: 3
                }
              }
            },
            symbol: 'diamond',
            data: this.dataset[1]
          },
          {
            name: this.locale('Actual','实际'),
            type: 'line',
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: serColors[2],
                fontSize: 16,
                lineStyle: {
                  width: 3
                }
              }
            },
            symbol: 'diamond',
            data: this.dataset[2]
          },
          {
            name: this.locale('Health','健康度'),
            type: 'bar',
            barWidth: 20,
            //color: '#ffffff',
            itemStyle: {
              normal: {
                //color: serColors[3],
                color: function(params) {
                  // 如果是预测值，就显示灰色，否则大于0显示黄色，小于0显示绿色
                  if (that.dataset[4][params.dataIndex] == 'Y') {
                    return '#778899'
                  } else {
                    if (params.data >= 0)
                      return serColors[3]
                    else
                      return serColors[4]
                  }
                },
                fontSize: 16
              }
            },
            data: this.dataset[3]
          }
        ]
      };
      /*
      var option1 = {
        title: {
          text: '健康度',
          textStyle: {
            color: '#fff',
            fontSize: 24
          },
          left: 'center'
        }
      };
      */
      // 5：展示数据
      myChart.setOption(option);
    }
  } 
};
</script>

<style lang="less" >
#bscdown2 {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  // border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
  .box {
    position: relative;
    height: 100%;
    width: 100%;
    display:block;
  }
}
</style>
